var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100CloseGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.495 3.49498C13.7684 3.22161 13.7684 2.7784 13.495 2.50503C13.2217 2.23166 12.7784 2.23166 12.5051 2.50503L8.00005 7.01005L3.49502 2.50503C3.22166 2.23166 2.77844 2.23166 2.50507 2.50503C2.23171 2.7784 2.23171 3.22161 2.50507 3.49498L7.0101 8L2.50507 12.505C2.23171 12.7784 2.23171 13.2216 2.50507 13.495C2.77844 13.7683 3.22166 13.7683 3.49502 13.495L8.00005 8.98995L12.5051 13.495C12.7784 13.7683 13.2217 13.7683 13.495 13.495C13.7684 13.2216 13.7684 12.7784 13.495 12.505L8.99 8L13.495 3.49498Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100CloseGray);
export default __webpack_public_path__ + "static/media/100-close-gray.de08df87278cb137a05f780f223b346b.svg";
export { ForwardRef as ReactComponent };